declare const module: any;
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

console.log('environment', environment);
if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err: Error) => console.error(err));
};

if (environment?.hmr) {
  if (module.hot) {
    module.hot.accept();
    module.hot.dispose(() => {
      // Before restarting the app, we create a new root element and dispose the old one
      const oldRootElem = document.querySelector('app-root');
      const newRootElem = document.createElement('app-root');
      if (oldRootElem && oldRootElem.parentNode) {
        oldRootElem.parentNode.insertBefore(newRootElem, oldRootElem);
      }
      module.hot.removeDisposeHandler(() => {
        if (oldRootElem && oldRootElem.parentNode) {
          oldRootElem.parentNode.removeChild(oldRootElem);
        }
      });
    });
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
  }
}

bootstrap();
